// extracted by mini-css-extract-plugin
export default {"customer-details":"customer-details_customer-details__1fLRH","customer-details__title":"customer-details_customer-details__title__oKLGC"};